import {
  BrickFormItem,
  BrickFormItemType,
  FlexibleBlockBrickForm,
  FlexibleBlockBrickText,
  FlexibleBlockProps,
  FlexibleBlockTemplateForm,
  PortalTextType,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils/blocks';
import { uuid } from '@nx-frontend/shared/utils/uuid';

export const getFormBlockTemplateItem = (type: BrickFormItemType): BrickFormItem => {
  const id = uuid(6);
  const baseProps = {
    id,
    type,
    required: false,
    cols: 2,
  };
  if (type === 'textarea') {
    return {
      ...baseProps,
      title: 'Large text input',
      placeholder: 'Enter text',
    };
  }
  if (type === 'number') {
    return {
      ...baseProps,
      title: 'Number input',
      placeholder: 'Enter number',
    };
  }
  if (type === 'checkbox') {
    return {
      ...baseProps,
      title: 'Checkbox',
    };
  }
  if (type === 'email') {
    return {
      ...baseProps,
      title: 'Email Address',
      placeholder: 'your-name@gmail.com',
    };
  }
  if (type === 'phone') {
    return {
      ...baseProps,
      title: 'Phone number',
      placeholder: 'Enter your phone number',
    };
  }
  return {
    ...baseProps,
    title: 'Small text input',
    placeholder: 'Enter text',
  };
};

export const getFormBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateForm>[] => {
  let brickIndex = -1;

  const brickCommon = {
    index: 0,
    enabled: true,
    sortable: true,
    removable: false,
    switchable: true,
  };

  const brickDescription: FlexibleBlockBrickText = {
    ...brickCommon,
    brickType: 'text',
    brickName: 'Description',
    text: 'Please fill out the form below with your contact and company information. Fields marked with an asterisk (*) are required.',
    placeholder: 'Here, you can add description',
    className: ['p-0', 'mb-2', 'text-base'],
    theme: { text: { main: PortalTextType.SURFACE } },
    index: ++brickIndex,
  };

  const brickForm: FlexibleBlockBrickForm = {
    ...brickCommon,
    brickType: 'form',
    brickName: 'Form content',
    mainBrick: true,
    index: ++brickIndex,
    submit: {
      show: false,
      text: 'Submit',
    },
    reusable: true,
    items: [
      {
        ...getFormBlockTemplateItem('text'),
        required: true,
        title: 'First name',
        placeholder: 'Enter your first name',
        cols: 1,
      },
      {
        ...getFormBlockTemplateItem('text'),
        required: true,
        title: 'Last name',
        placeholder: 'Enter your last name',
        cols: 1,
      },
      {
        ...getFormBlockTemplateItem('email'),
        required: true,
        title: 'Contact email',
        placeholder: 'Enter your email',
        cols: 1,
      },
      {
        ...getFormBlockTemplateItem('text'),
        title: 'Project name',
        placeholder: 'Enter your project name',
        cols: 1,
      },
      {
        ...getFormBlockTemplateItem('textarea'),
        title: 'Project overview',
        placeholder: 'Tell us about project',
      },
    ],
  };

  return [
    {
      title: 'Form',
      wrapper: getWrapperProps('blank'),
      template: {
        type: 'form',
        view: 'basic',
      },
      bricks: [brickDescription, brickForm],
      className: ['gap-4'],
    },
  ];
};
